<app-menu></app-menu>
<div class="container-fluid">
    <div class="col-lg-12 mt-5">
        <h1>Listado de Productos</h1>
        <hr>
        <div class="row d-none d-lg-block d-xl-block">
            <div class="form-group col-6">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"><i class="fa fa-search"></i></span>
                    </div>
                    <input type="text" class="form-control" [(ngModel)]="filterProducto" name="filterProducto" placeholder="Buscar producto..." autocomplete="off">
                </div>
            </div>
            <div class="col text-right">
                <button class="btn btn-success" [routerLink]="['/nuevoProducto']">
                    <i class="fa fa-plus"></i>
                    Agregar
                </button>
            </div>
        </div>
        <div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
            <div class="form-group col-12">
                <div class="input-group">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1"><i class="fa fa-search"></i></span>
                    </div>
                    <input type="text" class="form-control" [(ngModel)]="filterProducto" name="filterProducto" placeholder="Buscar producto..." autocomplete="off">
                </div>
            </div>
            <div class="col-12 text-right">
                <button class="btn btn-success" [routerLink]="['/nuevoProducto']">
                    <i class="fa fa-plus"></i>
                    Agregar
                </button>
            </div>
        </div>
        <div class="table-responsive">
            <table class="table mt-3 animated fadeIn faster">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Producto</th>
                        <th scope="col">Nombre</th>
                        <th scope="col">Categoría</th>
                        <th scope="col">Acciones</th>
                    </tr>
                </thead>
                <tbody class="text-center">
                    <tr *ngFor="let item of productosList | filter:filterProducto">
                        <td><img [src]="item.imageProd" class="img-fluid img-thumbnail" width="80" alt="..."> </td>
                        <td>
                            <h4>{{item.nombre}}</h4>
                        </td>
                        <td>{{item.categoria}}</td>
                        <td>
                            <button class="btn btn-warning mr-1" title="Detalle" (click)="productoSelected(item.id)" data-toggle="modal" data-target="#promocion">
                                <i class="fa fa-percent"></i>
                            </button>
                            <button class="btn btn-info mr-1" title="Detalle" (click)="detalleProducto(item)" data-toggle="modal" data-target="#producto">
                                <i class="fa fa-list"></i>
                            </button>
                            <button class="btn btn-success mr-1" title="Editar" (click)="edicionProducto(item.id)" data-toggle="modal" data-target="#producto">
                                <i class="fa fa-edit"></i>
                            </button>
                            <button class="btn btn-danger" title="Eliminar" (click)="borrarProducto(item)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>
<!-- Modal -->
<div class="modal fade" id="producto" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Detalle Producto</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div class="col-12 mt-5 d-none d-lg-block d-xl-block">
                    <div class="row">
                        <div class="col-6">
                            <img [src]="imagen" class="img-fluid" width="80%" alt="Responsive image">
                        </div>
                        <div class="col-5">
                            <div class="text-center mt-5">
                                <img *ngIf="categoria == 'TAYCO'" src="../../../assets/img/tayco.png" alt="">
                                <img *ngIf="categoria == 'ASEO'" src="../../../assets/img/suped.png" alt="">
                                <h2 class="prod">{{nombre | titlecase}}</h2>
                            </div>
                            <div>
                                <h4 class="descr">{{descripcion}}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="card h-100">
                                <div class="card-body">
                                    <div>
                                        <h2 style="color:  rgb(71, 69, 69);" class="card-title">Presentaciones disponibles:</h2>
                                        <button *ngIf="gr1000" title="1000 gr" (click)="precioPresentacion(gr1000)" class="btn btn-primary prc ml-1">1000g</button>
                                        <button *ngIf="gr1500" title="1500gr" (click)="precioPresentacion(gr1500)" class="btn btn-primary prc ml-1">1500g</button>
                                        <button *ngIf="ltrPist" title="Litro Pistola" (click)="precioPresentacion(ltrPist)" class="btn btn-light prc ml-1"><img src="../../../assets/img/1ltpistola.png" width="100" alt=""></button>
                                        <button *ngIf="ltrPistRep" title="Litro Pistola" (click)="precioPresentacion(ltrPistRep)" class="btn btn-light prc ml-1"><img src="../../../assets/img/1ltpistolaRep.png" width="100" alt=""></button>
                                        <button *ngIf="ltr" title="1 Litro" (click)="precioPresentacion(ltr)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/1lt.png" width="100" alt=""></button>
                                        <button *ngIf="ltrVal" title="1 Litro Válvula" (click)="precioPresentacion(ltrVal)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/1ltvalvula.png" width="100" alt=""></button>
                                        <button *ngIf="ltr38" title="3.8 Litros" (click)="precioPresentacion(ltr38)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/38lt.png" width="100" alt=""></button>
                                        <button *ngIf="ltr5" title="5 Litros" (click)="precioPresentacion(ltr5)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/5lts.png" width="100" alt=""></button>
                                        <button *ngIf="ltr20" title="20 Litros" (click)="precioPresentacion(ltr20)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/20lts.png" width="100" alt=""></button>
                                        <button *ngIf="kg1" title="1 Kilo" (click)="precioPresentacion(kg1)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg1.png" width="100" alt=""></button>
                                        <button *ngIf="kg4" title="4 Kilos" (click)="precioPresentacion(kg4)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg4.png" width="100" alt=""></button>
                                        <button *ngIf="kg21" title="21 Kilos" (click)="precioPresentacion(kg21)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg21.png" width="100" alt=""></button>
                                        <button *ngIf="kg22" title="22 Kilos" (click)="precioPresentacion(kg22)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg22.png" width="100" alt=""></button>
                                        <button *ngIf="kg44" title="4.4 Kilos" (click)="precioPresentacion(kg44)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg44.png" width="100" alt=""></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="card h-100">
                                <div class="card-body">
                                    <div>
                                        <button *ngIf="kiwi == 'Si'" class="btn btn-success ml-1">Kiwi</button>
                                        <button *ngIf="limon == 'Si'" class="btn btn-success ml-1">Limón</button>
                                        <button *ngIf="sinAroma == 'Si'" class="btn btn-success ml-1">Sin Aroma</button>
                                        <button *ngIf="floral == 'Si'" class="btn btn-success ml-1">Floral</button>
                                        <button *ngIf="citronela == 'Si'" class="btn btn-success ml-1">Citronela</button>
                                        <button *ngIf="lavanda == 'Si'" class="btn btn-success ml-1">Lavanda</button>
                                        <button *ngIf="vinagre == 'Si'" class="btn btn-success ml-1">Vinagre</button>
                                        <button *ngIf="frutosRojos == 'Si'" class="btn btn-success ml-1">Frutos Rojos</button>
                                        <button *ngIf="tL == 'Si'" class="btn btn-success ml-1">Talla L</button>
                                        <button *ngIf="tM == 'Si'" class="btn btn-success ml-1">Talla M</button>
                                        <button *ngIf="tS == 'Si'" class="btn btn-success ml-1">Talla S</button>

                                        <button *ngIf="amarillo == 'Si'" class="btn btn-warning ml-1">Amarillo</button>
                                        <button *ngIf="azul == 'Si'" class="btn btn-primary ml-1">Azul</button>
                                        <button *ngIf="rojo == 'Si'" class="btn btn-danger ml-1">Rojo</button>
                                        <button *ngIf="gris == 'Si'" class="btn btn-secondary ml-1">Gris</button>
                                        <button *ngIf="verde == 'Si'" class="btn btn-success ml-1">Verde</button>
                                        <button *ngIf="negro == 'Si'" class="btn btn-dark ml-1">Negro</button>
                                        <button style="background-color: beige;border: solid;border-width: 1px;border-color: black;" *ngIf="blanco == 'Si'" class="btn btn-light ml-1">Blanco</button>
                                    </div>
                                    <div class="text-center mt-3">
                                        <h1>${{precio | number}}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="d-xs-block d-sm-block d-md-block d-lg-none d-xl-none">
                    <div class="col-12">
                        <img [src]="imagen" class="img-fluid" width="80%" alt="Responsive image">
                    </div>
                    <div class="col-12">
                        <div class="text-center mt-5">
                            <img *ngIf="categoria == 'TAYCO'" src="../../../assets/img/tayco.png" alt="">
                            <img *ngIf="categoria == 'ASEO'" src="../../../assets/img/suped.png" alt="">
                            <h2 class="prod">{{nombre | titlecase}}</h2>
                        </div>
                        <div>
                            <h4 class="descr">{{descripcion}}</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-6">
                            <div class="card h-100">
                                <div class="card-body">
                                    <div>
                                        <h2 style="color:  rgb(71, 69, 69);" class="card-title">Presentaciones disponibles:</h2>
                                        <button *ngIf="gr1000" title="1000 gr" (click)="precioPresentacion(gr1000)" class="btn btn-primary prc ml-1">1000g</button>
                                        <button *ngIf="gr1500" title="1500gr" (click)="precioPresentacion(gr1500)" class="btn btn-primary prc ml-1">1500g</button>
                                        <button *ngIf="ltrPist" title="Litro Pistola" (click)="precioPresentacion(ltrPist)" class="btn btn-light prc ml-1"><img src="../../../assets/img/1ltpistola.png" width="100" alt=""></button>
                                        <button *ngIf="ltrPistRep" title="Litro Pistola" (click)="precioPresentacion(ltrPistRep)" class="btn btn-light prc ml-1"><img src="../../../assets/img/1ltpistolaRep.png" width="100" alt=""></button>
                                        <button *ngIf="ltr" title="1 Litro" (click)="precioPresentacion(ltr)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/1lt.png" width="100" alt=""></button>
                                        <button *ngIf="ltrVal" title="1 Litro Válvula" (click)="precioPresentacion(ltrVal)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/1ltvalvula.png" width="100" alt=""></button>
                                        <button *ngIf="ltr38" title="3.8 Litros" (click)="precioPresentacion(ltr38)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/38lt.png" width="100" alt=""></button>
                                        <button *ngIf="ltr5" title="5 Litros" (click)="precioPresentacion(ltr5)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/5lts.png" width="100" alt=""></button>
                                        <button *ngIf="ltr20" title="20 Litros" (click)="precioPresentacion(ltr20)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/20lts.png" width="100" alt=""></button>
                                        <button *ngIf="kg1" title="1 Kilo" (click)="precioPresentacion(kg1)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg1.png" width="100" alt=""></button>
                                        <button *ngIf="kg4" title="4 Kilos" (click)="precioPresentacion(kg4)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg4.png" width="100" alt=""></button>
                                        <button *ngIf="kg21" title="21 Kilos" (click)="precioPresentacion(kg21)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg21.png" width="100" alt=""></button>
                                        <button *ngIf="kg22" title="22 Kilos" (click)="precioPresentacion(kg22)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg22.png" width="100" alt=""></button>
                                        <button *ngIf="kg44" title="4.4 Kilos" (click)="precioPresentacion(kg44)" class="btn btn-light ltsp ml-1"><img src="../../../assets/img/kg44.png" width="100" alt=""></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-6">
                            <div class="card h-100">
                                <div class="card-body">
                                    <div>
                                        <button *ngIf="kiwi == 'Si'" class="btn btn-success ml-1">Kiwi</button>
                                        <button *ngIf="limon == 'Si'" class="btn btn-success ml-1">Limón</button>
                                        <button *ngIf="sinAroma == 'Si'" class="btn btn-success ml-1">Sin Aroma</button>
                                        <button *ngIf="floral == 'Si'" class="btn btn-success ml-1">Floral</button>
                                        <button *ngIf="citronela == 'Si'" class="btn btn-success ml-1">Citronela</button>
                                        <button *ngIf="lavanda == 'Si'" class="btn btn-success ml-1">Lavanda</button>
                                        <button *ngIf="vinagre == 'Si'" class="btn btn-success ml-1">Vinagre</button>
                                        <button *ngIf="frutosRojos == 'Si'" class="btn btn-success ml-1">Frutos Rojos</button>
                                        <button *ngIf="tL == 'Si'" class="btn btn-success ml-1">Talla L</button>
                                        <button *ngIf="tM == 'Si'" class="btn btn-success ml-1">Talla M</button>
                                        <button *ngIf="tS == 'Si'" class="btn btn-success ml-1">Talla S</button>

                                        <button *ngIf="amarillo == 'Si'" class="btn btn-warning ml-1">Amarillo</button>
                                        <button *ngIf="azul == 'Si'" class="btn btn-primary ml-1">Azul</button>
                                        <button *ngIf="rojo == 'Si'" class="btn btn-danger ml-1">Rojo</button>
                                        <button *ngIf="gris == 'Si'" class="btn btn-secondary ml-1">Gris</button>
                                        <button *ngIf="verde == 'Si'" class="btn btn-success ml-1">Verde</button>
                                        <button *ngIf="negro == 'Si'" class="btn btn-dark ml-1">Negro</button>
                                        <button style="background-color: beige;border: solid;border-width: 1px;border-color: black;" *ngIf="blanco == 'Si'" class="btn btn-light ml-1">Blanco</button>

                                    </div>
                                    <div class="text-center mt-3">
                                        <h1>${{precio | number}}</h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Modal promocion -->
<div class="modal fade" id="promocion" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Asignar porcentaje de descuento al este producto:</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
            </div>
            <div class="modal-body">
                <div class="input-group mb-3">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">%</span>
                    </div>
                    <input type="number" class="form-control" placeholder="Ingrese porcentaje" [(ngModel)]="descuento">
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">Cerrar</button>
                <button type="button" class="btn btn-dark" (click)="asignarDescuento()">Asignar porcentaje</button>
            </div>
        </div>
    </div>
</div>